import { credibilityContent } from "./credibilityContent"
import {
  countLabel,
  EMPTY_VALUE,
  formatPercent,
  formatResponseTime,
  LOADING_VALUE,
} from "../benchmarkApi/reportData"

const kpiValueClass =
  "text-[24px] font-bold leading-8 tracking-[-0.04em] text-[#171717]"
const kpiLabelClass = "text-[13px] font-light leading-[18px] text-[#171717]"

function liveValue(statsStatus, value) {
  if (statsStatus === "loading") return LOADING_VALUE
  if (statsStatus !== "ready") return EMPTY_VALUE
  return value
}

function averageValue(statsStatus, stats) {
  if (statsStatus !== "ready") return liveValue(statsStatus, EMPTY_VALUE)
  if (typeof stats?.avg_response_time_seconds !== "number") return EMPTY_VALUE
  return formatResponseTime(stats.avg_response_time_seconds)
}

export default function CredibilitySection({ stats, statsStatus }) {
  const count = countLabel(statsStatus, stats?.total_companies)
  const values = {
    slow: liveValue(statsStatus, formatPercent(stats?.no_reply_or_slow_percent)),
    average: averageValue(statsStatus, stats),
    fast: liveValue(statsStatus, formatPercent(stats?.fast_reply_percent)),
    leakage: credibilityContent.kpis.find((item) => item.id === "leakage").value,
  }

  return (
    <section className="flex w-full translate-x-[calc(50vw-50%-1.5rem)] flex-col gap-8 pt-16 md:pt-24 lg:pt-36">
      <div className="flex flex-col gap-3">
        <p className="text-[14px] font-medium leading-5 text-[#4D4D4D]">
          {credibilityContent.eyebrow}
        </p>
        <h1 className="text-balance text-[40px] font-bold leading-[48px] tracking-[-0.04em] text-[#171717] max-md:text-[28px] max-md:leading-8">
          {credibilityContent.h1}
        </h1>
      </div>
      <p className="max-w-[68ch] text-[18px] font-normal leading-7 text-[#4D4D4D]">
        {credibilityContent.subheadline.replaceAll("{count}", count)}
      </p>
      <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {credibilityContent.kpis.map((item) => (
          <div
            key={item.id}
            className="flex flex-col gap-2 rounded-[2px] border border-solid border-[#E6E6E6] bg-white p-6"
          >
            <p className={kpiValueClass}>{values[item.id]}</p>
            <p className={kpiLabelClass}>{item.label}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
